import LoginPage from 'Pages/LoginPage/LoginPage';
import BelzLoginPage from 'Pages/LoginPage/Whitelabel/BelzLoginPage';
import ReedMackayLoginPage from 'Pages/LoginPage/Whitelabel/ReedMackayLoginPage';
import TakeMeLoginPage from 'Pages/LoginPage/Whitelabel/TakeMeLoginPage';
import TysersLoginPage from 'Pages/LoginPage/Whitelabel/TysersLoginPage';
import VeezuBBCLoginPage from 'Pages/LoginPage/Whitelabel/VeezuBBCLoginPage';
import VeezuLoginPage from 'Pages/LoginPage/Whitelabel/VeezuLoginPage';
import ResetPasswordPage from '../../Pages/ConfirmEmailPage/ResetPasswordPage';
import ForgotPasswordPage from '../../Pages/ForgotPasswordPage/ForgotPasswordPage';

let LoginPageComponent

switch (true) {
  case window.location.hostname.includes('belz'):
    LoginPageComponent = BelzLoginPage
    break
  case window.location.hostname.includes('reedmackay'):
    LoginPageComponent = ReedMackayLoginPage
    break
  case window.location.hostname.includes('tysers'):
    LoginPageComponent = TysersLoginPage
    break
  case window.location.hostname.includes('veezustaging'):
    LoginPageComponent = VeezuBBCLoginPage
    break
  case window.location.hostname.includes('veezu'):
    LoginPageComponent = VeezuLoginPage
    break
  case window.location.hostname.includes('takeme'):
    LoginPageComponent = TakeMeLoginPage
    break
  case window.location.hostname.startsWith('localhost'):
    LoginPageComponent = LoginPage
    break
  default:
    LoginPageComponent = LoginPage
    break
}

var authRoutes = [
  {
    path: '/login',
    name: 'Login Page',
    rtlName: 'هعذاتسجيل الدخول',
    mini: 'L',
    rtlMini: 'هعذا',
    component: LoginPageComponent,
    layout: '/auth',
    redirect: true,
  },
  {
    path: '/forgotPassword',
    name: 'Forgot Password',
    rtlName: 'ملف تعريفي للمستخدم',
    mini: 'UP',
    rtlMini: 'شع',
    component: ForgotPasswordPage,
    layout: '/auth',
    redirect: true,
  },
  {
    path: '/resetPassword',
    name: 'Reset Password',
    rtlName: 'تسجيل',
    mini: 'R',
    rtlMini: 'صع',
    component: ResetPasswordPage,
    layout: '/auth',
    redirect: true,
  },
  {
    path: '/completeRegistration',
    name: 'Complete Registration',
    rtlName: 'تسجيل',
    mini: 'R',
    rtlMini: 'صع',
    component: ResetPasswordPage,
    layout: '/auth',
    redirect: true,
  },
]

export default authRoutes
